








import {
    defineComponent,
} from '@vue/composition-api';
export default defineComponent({
    props: {
        errorText: {
            type: String,
            default: '作品已失效',
        },
    },
    setup() {
        return {
        };
    },
});
